import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import {TABLET_BREAKPOINT} from '../utils/constants';
import AboveFold from '../components/common/above-fold/AboveFold';
import SEOTextModule from '../components/destination/seo-text/SEOTextModule';
import LinkPilesModule from '../components/common/linkpiles/LinkPilesModule';
import PopularDestinationsModule from '../modules/PopularDestinations/PopularDestinationsModule';
import PropertyTypesModule from '../modules/PropertyTypes/PropertyTypesModule';
import GreatPlacesToStayModule from '../modules/GreatPlacesToStay/GreatPlacesToStayModule';
import {AsyncFamilyFriendly} from '../modules/FamilyFriendly/AsyncFamilyFriendly';
import {DateModal} from '../components/common/date-modal/DateModal';
import {AsyncDestinationUrgency} from '../modules/UrgencyMessage/AsyncDestinationUrgency';
import {AsyncDestinationInfographic} from '../components/common/destination-infographic/AsyncDestinationInfographic';
import ReviewsModule from '../components/common/review/ReviewsModule';
import DynamicSeoLinkpile from '../components/common/seo-linkpile/DynamicSeoLinkpile';
import {ScrollToTopButton} from '../components/ScrollToTopButton';
import {AsyncRecentTravelerActivity} from '../components/common/recent-traveler-activity/AsyncRecentTravelerActivity';
import DynamicQuestionModule from '../components/destination/dynamic-seo-questions/DynamicQuestionModule';
import {TESTS} from '../utils/abacus';
import {AsyncExploreBookEnjoy} from '../components/destination/explore-book-enjoy/AsyncExploreBookEnjoy';
import {AsyncToaster} from '../components/common/toaster/AsyncToaster';
import {AsyncTripBoardModal} from '../components/common/tripboard/AsyncTripBoardModal';
import {AsyncRecommendedProperties} from '../components/destination/recommended-properties/AsyncRecommendedProperties';
import {AsyncMapProperties} from '../components/destination/map-properties/AsyncMapProperties';
import DynamicDestinationRefinements from '../components/destination/destination-refinements/DynamicDestinationRefinements';
import {PointsOfInterestModule} from '../modules/PointsOfInterest/PointsOfInterestModule';
import {AsyncAATestModule} from '../modules/AATest/AsyncAATestModule';

import {
    fullExposures,
    lazy,
    withErrorBoundary,
    withTripboardsLazy,
    withTripboards,
} from './helpers';
import ContentHubModule from '../modules/ContentHub/ContentHubModule';

export const fullExposureTests = [
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.DYNAMIC_RENDERING_2,
    TESTS.DYNAMIC_REFINEMENTS_MOBILE,
    TESTS.DYNAMIC_SEO_INTRO_PARAGRAPH,
    TESTS.DYNAMIC_SEO_INTRO_PARAGRAPH_OTHER_POS,
    TESTS.DYNAMIC_SEO_INTRO_PARAGRAPH_OTHER_POS_TRAFFIC,
    TESTS.SLP_TRAFFIC_TEST_AA,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.SLP_TOP_X_BEST_META_TITLE_TRAFFIC_TEST,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT,
    TESTS.HEADING_CONVERSION,
    TESTS.HEADING_TRAFFIC,
    TESTS.ROADTRIPS_SITE_NAVIGATION,
    TESTS.ROADTRIPS_SITE_NAVIGATION_NEW_LABEL,
    TESTS.DISCOVERY_SITE_NAVIGATION,
    TESTS.DISCOVERY_SITE_NAVIGATION_NEW_LABEL,
    TESTS.VRBO_LANDING_SLP_BRANDED_HEADINGS,
];

function TemplateComponent(props) {
    const {
        isMobile,
        hasTouch,
        dispatch,
        hasMABData,
        showDynamicDestinationRefinements,
        showPlaceholders,
        showPointsOfInterest,
        showGreatPlacesToStay,
    } = props;

    useEffect(() => {
        dispatch({
            type: 'SET_VIEWPORT',
            payload: {isMobile, hasTouch},
        });
    }, [dispatch, isMobile, hasTouch]);

    const mainCSSClass = classNames('app-main', {
        'container--loading__visible': showPlaceholders,
    });
    const mabTest = hasMABData ? [TESTS.HA_PTA_LANDING_SLPHEROMAB] : [];

    return (
        <>
            <main className={mainCSSClass}>
                {fullExposures([...fullExposureTests, ...mabTest])}
                <AboveFold />
                {withTripboardsLazy(<AsyncRecentTravelerActivity />)}
                {withTripboardsLazy(<AsyncRecommendedProperties />)}
                {showDynamicDestinationRefinements &&
                    lazy(<DynamicDestinationRefinements />)}
                {lazy(<AsyncDestinationUrgency />)}
                {withErrorBoundary(<PopularDestinationsModule />)}
                {withErrorBoundary(<PropertyTypesModule />)}
                {showPointsOfInterest
                    ? lazy(<PointsOfInterestModule />)
                    : lazy(<AsyncMapProperties />)}
                {lazy(<AsyncAATestModule />)}
                {withTripboardsLazy(<AsyncFamilyFriendly />)}
                {showGreatPlacesToStay &&
                    withTripboards(<GreatPlacesToStayModule />)}
                {withTripboards(<ReviewsModule />)}
                {lazy(<AsyncDestinationInfographic />)}
                {lazy(<AsyncExploreBookEnjoy />)}
                {withErrorBoundary(<SEOTextModule />)}
                {withErrorBoundary(<DynamicQuestionModule />)}
                {withErrorBoundary(<ContentHubModule />)}
                {withErrorBoundary(<LinkPilesModule />)}
                {lazy(<ScrollToTopButton />)}
                {withErrorBoundary(<DateModal />)}
            </main>
            {withErrorBoundary(<DynamicSeoLinkpile />)}
            {withErrorBoundary(<AsyncToaster />)}
            {withErrorBoundary(<AsyncTripBoardModal />)}
        </>
    );
}

export function mapStateToProps({mab = {}, pointsOfInterest, options}) {
    return {
        hasMABData: !!mab.arm,
        showDynamicDestinationRefinements:
            options.destinationRefinementsMode !== 'disabled',
        showPlaceholders: options.showPlaceholders,
        showPointsOfInterest: pointsOfInterest.enabled,
        showGreatPlacesToStay: options.showGreatPlacesToStay,
    };
}

export const Template = connect(mapStateToProps)(
    determineIfMobile(TemplateComponent, TABLET_BREAKPOINT)
);

Template.displayName = 'Template';

export default Template;
